import React, { Component } from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import {withStyles,Button,IconButton,Dialog,Typography,Grid,Paper
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';
import { ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import Snackbar from "@material-ui/core/Snackbar";
import Alert from '@material-ui/lab/Alert';
import {getKundKontakter,createNewEvent,getKundAvtalProspekt,onSetZeroKundSearch,getSignatures,onRefeshOutlookToken} from 'actions'
import {isUndefined,isEmpty, isNull} from 'lodash'
import moment from 'moment';
import CustomScrollbars from 'util/CustomScrollbars';
import KundInfo from './KundInfo'
import Kontakt from './Kontakt'
import Ansvarig from './Ansvarig'
import AvtalProspekt from './AvtalProspekt'
import Mote from './Mote'
import Kommentar from '../../SkapaMote/Inputs/Kommentar'
import FilesBilagor from '../../SkapaMote/Inputs/FilesBilagor'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AnteckningDelJ from 'components/NotyfileAnteckningInputJ/EditIndexJ'
import { injectIntl } from 'react-intl';

const withMediaQuery = (queries = []) => Component => props => {
    const mediaProps = {}
    queries.forEach(q => {
      mediaProps[q[0]] = useMediaQuery(q[1])
    })
    return <Component {...mediaProps} {...props} />
  }

const styles = theme => ({
    root: {
        padding: theme.spacing(2),
        margin: theme.spacing(4),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

function mapStateToProps({auth,Event,accountsData,Avtal,Mail}) {
    const { authUser} = auth;
    const { isLoadingEvent,Eventmessage } = Event;
    const { ListOfAVPro } = Avtal;
    const { signatures } = Mail;
    const { KontakterList ,KundSearch,HasOutlook,EventsSetting} = accountsData;
    return {
        isLoadingEvent,Eventmessage,authUser,KontakterList,KundSearch,HasOutlook,ListOfAVPro,signatures,EventsSetting
    };
}

function mapDispatchToProps(dispatch) {
    return {
        createNewEvent: (userid,AFid,NEvent) => dispatch(createNewEvent(userid,AFid,NEvent)),
        getKundKontakter: (userid,AFid,Orgnr) => dispatch(getKundKontakter(userid,AFid,Orgnr)),
        getKundAvtalProspekt: (Orgnr, Afid, userid) => dispatch(getKundAvtalProspekt(Orgnr, Afid, userid)),
        getSignatures: (Afid, Userid,AuthUserid) => dispatch(getSignatures(Afid, Userid,AuthUserid)),
        onRefeshOutlookToken: ( Userid,Afid) => dispatch(onRefeshOutlookToken(Userid,Afid)),
        onSetZeroKundSearch: () => dispatch(onSetZeroKundSearch()),
    };
}
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});
const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

class PopUpBM extends Component {
    state = {
        KontakterList:[],
        error:false,
        errorMessage:<IntlMessages id="Incorrect.fields.error"/>, 
        Mote:{
            Taggar: [],
            Kund:{
            KundNamn:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].KundNamn,
            Orgnr:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].Orgnr,
            Orgnr_Af:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].Orgnr_Af,
            Adress:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].adress,
            Postnr:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].postnr,
            Ort:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].ort,
            Source:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].Source,
            Active:isUndefined(this.props.currentKund)?"":this.props.currentKund.isActive
            },
            Kontakt:{
                id:"",
                FirstName:"",
                LastName:"",
                Email:"",
                Tele:"",
                Role:"",
                PersonNr:""
            },
            Avtal:0, 
            HasTeam:isUndefined(this.props.EventsSetting.TeamLinks)?"":this.props.EventsSetting.TeamLinks,
            InViteKontakt:isUndefined(this.props.EventsSetting.StandardBjudaIn)?0:this.props.EventsSetting.StandardBjudaIn,
            inViteFrom:0,
            AvtalType:0,
            ProspektDeadline:moment(new Date()).format("YYYY-MM-DD HH:mm"),
            ansvarig:this.props.authUser.user_id,
            MotUser:this.props.authUser.user_id,
            MedArbetare:[],
            SendNSms:0,
            TeleNummer:"",
            Event:{
                endDatetime:(isNull(this.props.selectedSlotEvent) || isUndefined(this.props.selectedSlotEvent)) ? 
                moment(new Date()).add(30,"minutes").tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm") : moment(new Date(this.props.selectedSlotEvent.end)).tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm"),
                // moment(new Date()).add(30,"minutes").tz("Europe/Stockholm"),
                startDatetime:(isNull(this.props.selectedSlotEvent) || isUndefined(this.props.selectedSlotEvent)) ? moment(new Date()).tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm") : moment(new Date(this.props.selectedSlotEvent.start)).tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm"),
                // moment(new Date()).tz("Europe/Stockholm"),
                ConfirmDatetime:moment(new Date()).tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm"),
                Type:0,
                Plats:"",
                Status:0,
                Syfte:isUndefined(this.props.EventsSetting.StandardSubject)?"":this.props.EventsSetting.StandardSubject,
                Body:"",
                Files:[],
                Internkommentar:"",
                nyttBefintlig:0,
            },
        }
    }
    handleClose=()=>{
        this.props.onSetZeroKundSearch()
        this.setState({
            KontakterList:[], 
            error:false,
            errorMessage:<IntlMessages id="Incorrect.fields.error"/>,
            Mote:{
            Taggar: [],
            Kund:{
            KundNamn:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].KundNamn,
            Orgnr:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].Orgnr,
            Orgnr_Af:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].Orgnr_Af,
            Adress:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].adress,
            Postnr:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].postnr,
            Ort:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].ort,
            Source:isUndefined(this.props.currentKund)?"":this.props.currentKund.Kund[0].Source,
            Active:isUndefined(this.props.currentKund)?"":this.props.currentKund.isActive
            },
            Kontakt:{
                id:"",
                FirstName:"",
                LastName:"",
                Email:"",
                Tele:"",
                Role:"",
                PersonNr:""
            },
            ansvarig:this.props.authUser.user_id,
            MotUser:this.props.authUser.user_id,
            MedArbetare:[],
            Avtal:0, 
            AvtalType:0,
            ProspektDeadline:moment(new Date()).format("YYYY-MM-DD HH:mm"),
            HasTeam:0,
            InViteKontakt:isUndefined(this.props.EventsSetting.StandardBjudaIn)?0:this.props.EventsSetting.StandardBjudaIn,
            inViteFrom:0,
            SendNSms:0,
            TeleNummer:"",
            Event:{
                endDatetime:moment(new Date()).add(30,"minutes").tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm"),
                startDatetime:moment(new Date()).tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm"),
                ConfirmDatetime:moment(new Date()).tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm"),
                Type:0,
                Plats:"",
                Status:0,
                Syfte:"",
                Body:"",
                Internkommentar:"",
                Files:[],
                nyttBefintlig:0
            },
        }  
        })
        this.props.handleClose()
    }
    onchangeHanelansvarig=(currenrAnsvarig)=>{
        const {user_Afid} = this.props.authUser
        this.props.onRefeshOutlookToken(currenrAnsvarig,user_Afid)
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                ansvarig:currenrAnsvarig
            }
        })
    }
    onchangeHanelMotUser=(currenrAnsvarig)=>{
        const {user_Afid} = this.props.authUser
        this.props.onRefeshOutlookToken(currenrAnsvarig,user_Afid)
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                MotUser:currenrAnsvarig
            }
        })
    }
    onchangeHanelKund=(Meta,Value)=>{
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                Kund:{
                ...this.state.Mote.Kund,
                [Meta]:Value
                }
            }
        })
    }
    selectthisKund=(selectedKund)=>{
        
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                Kund:{
                    KundNamn:this.props.KundSearch.KundNamn,
                    Orgnr:this.props.KundSearch.Orgnr,
                    Orgnr_Af:this.props.KundSearch.Orgnr_Af,
                    Adress:this.props.KundSearch.adress,
                    Postnr:this.props.KundSearch.postnr,
                    Ort:this.props.KundSearch.ort,
                    Source:this.props.KundSearch.Source,
                    Active:this.props.KundSearch.Active, 
                },
                Kontakt:{
                    id:"",
                    FirstName:"",
                    LastName:"",
                    Email:"",
                    Tele:"",
                    Role:"",
                    PersonNr:""
                },
                TeleNummer:""
            }
        })
        //&& this.props.KundSearch.Source===1
        if(!isUndefined(this.props.KundSearch.Orgnr) ){
            const userid = this.props.authUser.user_id;
            const Kontoid = this.props.authUser.user_Afid;
            this.props.getKundKontakter(userid,Kontoid,this.props.KundSearch.Orgnr)
            this.props.getKundAvtalProspekt(this.props.KundSearch.Orgnr,Kontoid,userid)
        }
        
    }
    onchangeHanelKontakt=(currenrKontakt)=>{
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                Kontakt:currenrKontakt,
                TeleNummer:currenrKontakt.Tele
            }
        })
    }
    onchangeHanelKontakt2=(Meta,Value)=>{
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                Kontakt:{
                ...this.state.Mote.Kontakt,
                [Meta]:Value
                },
                TeleNummer: Meta ==="Tele"?Value:this.state.Mote.TeleNummer
            }
        })
    }
    //onAddHanelInbjuda
    onchangeHanelMedArbetare=(MedArbetare)=>{
            this.setState({
                ...this.state,
                Mote:{
                    ...this.state.Mote,
                    MedArbetare:MedArbetare
                }
            })
    }
    onchangeHanelAvtal=(Avtal)=>{
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                Avtal:Avtal
            }
        })
    }
    onchangeHanelAvtalType=(Meta,Avtal)=>{
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                AvtalType:Avtal
            }
        })
    }
    onchangeHanelProspektDeadline=(ProspektDeadline)=>{
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                ProspektDeadline:ProspektDeadline
            }
        })
    }
    onchangeHanelInViteKontakt=(Meta,InViteKontakt)=>{
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                InViteKontakt:InViteKontakt
            }
        })
    }
    onchangeHanelInViteFrom=(Meta,InViteFrom)=>{
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                inViteFrom:InViteFrom
            }
        })
    }
    onchangeHanelHasTeam=(Meta,HasTeam)=>{
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                HasTeam:HasTeam
            }
        })
    }
    onchangeHanelSendSms=(Meta,sendNSms)=>{

        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                SendNSms:sendNSms
            }
        })
    }
    onchangeHanelTeleNummer=(Meta,TeleNu)=>{
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                TeleNummer:TeleNu
            }
        })
    }
    onchangeTaggar = (Taggar) => {
        this.setState({
            ...this.state, 
            Mote: {
                ...this.state.Mote,
                Taggar: Taggar
            }
        })
    }
    onChangeDateRange=(selectedDate)=>{
        console.log(selectedDate)
        if(!isNull(selectedDate)){
            this.setState({
                ...this.state,
                Mote:{
                    ...this.state.Mote,
                    ansvarig:selectedDate.ansvarig,
                    Event:{
                    ...this.state.Mote.Event,
                    startDatetime:selectedDate.start,
                    endDatetime:selectedDate.end
                    }
                }
            })
        }
    }
    onchangeHanelEvent=(Meta,Value,Value2)=>{
        if(Meta === "startDatetime"){
            //console.log(moment(Value).add(1, 'hours'))
            this.setState({
                ...this.state,
                Mote:{
                    ...this.state.Mote,
                    Event:{
                    ...this.state.Mote.Event,
                    startDatetime:Value,
                    endDatetime:Value2
                    }
                }
            })
        }
        //Boka möte - Platsdetaljer visas även fast man valt webbmöte// Emma ,, 2024-04-16
        else if(Meta === 'Type'){
            if(parseInt(Value) === 1){
                this.setState({
                    ...this.state,
                    Mote:{
                        ...this.state.Mote,
                        Event:{
                        ...this.state.Mote.Event,
                        [Meta]:Value,
                        Plats:""
                        }
                    }
                })
            }else{
                this.setState({
                    ...this.state,
                    Mote:{
                        ...this.state.Mote,
                        Event:{
                        ...this.state.Mote.Event,
                        [Meta]:Value,
                        }
                    }
                })
            }
        }
        else{
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                Event:{
                ...this.state.Mote.Event,
                [Meta]:Value
                }
            }
        })
    }
    }
    onAddSignatur=(signature)=>{
        let Body = this.state.Mote.Event.Body + "<br/><br/>"+ signature.Body
        console.log(Body)
        this.setState({
            ...this.state,
            Mote:{
                ...this.state.Mote,
                Event:{
                ...this.state.Mote.Event,
                Body:Body
                }
            }
        })
    }
    createNewEvent=()=>{
        if(this.onCheckReq()){
            console.log("error")
        }
        else{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        const Mote =this.state.Mote;
        this.props.createNewEvent(userid,Afid,Mote)  
        this.handleClose()
        }
    }
    onCheckReq=()=>{
        if(
            isEmpty(this.state.Mote.Kund.Orgnr) ||
            isEmpty(this.state.Mote.Kontakt.FirstName) ||
            isNaN(this.state.Mote.Kontakt.id)  ||
            isEmpty(this.state.Mote.Event.Syfte) 
        ){
            this.setState({
                error:true
            })
            return true
        }else{
            this.setState({
                error:false
            })
            return false  
        }
    }
    componentWillReceiveProps = (nextProps) => {
      if(!isUndefined(this.props.selectedSlotEvent)) {
        if (nextProps.selectedSlotEvent !== this.props.selectedSlotEvent) {
          this.setState({
            ...this.state,
            Mote:{
              ...this.state.Mote,
              Event:{
                ...this.state.Mote.Event,
                endDatetime:(isNull(nextProps.selectedSlotEvent) || isUndefined(nextProps.selectedSlotEvent)) ? moment(new Date()).add(30,"minutes").tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm") : moment(new Date(nextProps.selectedSlotEvent.end)).tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm"),
                // moment(new Date()).add(30,"minutes").tz("Europe/Stockholm"),
                startDatetime:(isNull(nextProps.selectedSlotEvent) || isUndefined(nextProps.selectedSlotEvent)) ? moment(new Date()).tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm") : moment(new Date(nextProps.selectedSlotEvent.start)).tz("Europe/Stockholm").format("YYYY-MM-DD HH:mm"),
              }
            }
          })
        }
      }
    }
    componentDidMount=()=>{
        const {user_id} = this.props.authUser
        const {user_Afid} = this.props.authUser
        this.props.getSignatures(user_Afid, user_id,user_id)
    }
    componentDidUpdate=()=>{
        if(this.props.KundSearch.Orgnr !== this.state.Mote.Kund.Orgnr){
            this.setState({
                ...this.state,
                Mote:{
                    ...this.state.Mote,
                    Kund:{
                        KundNamn:this.props.KundSearch.KundNamn,
                        Orgnr:this.props.KundSearch.Orgnr,
                        Orgnr_Af:this.props.KundSearch.Orgnr_Af,
                        Adress:this.props.KundSearch.adress,
                        Postnr:this.props.KundSearch.postnr,
                        Ort:this.props.KundSearch.ort,
                        Source:this.props.KundSearch.Source,
                        Active:this.props.KundSearch.Active, 
                    },
                    Kontakt:{
                        id:"",
                        FirstName:"",
                        LastName:"",
                        Email:"",
                        Tele:"",
                        Role:"",
                        PersonNr:""
                    },
                }
            })
            //&& this.props.KundSearch.Source===1
            if(!isUndefined(this.props.KundSearch.Orgnr) ){
                const userid = this.props.authUser.user_id;
                const Kontoid = this.props.authUser.user_Afid;
                this.props.getKundKontakter(userid,Kontoid,this.props.KundSearch.Orgnr)
                this.props.getKundAvtalProspekt(this.props.KundSearch.Orgnr,Kontoid,userid)
            } 
        }
    }
    render() {
        console.log(this.props.EventsSetting,"syfte")
        const InterKommPlaceholder=this.props.intl.formatMessage({ id: 'Event.Interan.Comment.placeHolder' });
        const { fullScreen } = this.props;
        return (
            <Dialog onClose={this.handleClose} aria-labelledby="customized-dialog-title" 
            fullScreen={fullScreen}
            open={this.props.open} 
            fullWidth={true}
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            maxWidth={isEmpty(this.state.Mote.Kund.Orgnr)?"sm":"lg"}>
<ModalHeader className="modal-box-header bg-primary text-white">
    <IntlMessages id="Event.Create"/>
    <IconButton className="text-white"
        onClick={this.handleClose}>
        <CloseIcon />
    </IconButton>
</ModalHeader>
<DialogContent dividers>
    <Grid container>
        <Grid item xs={12} className={""}>
        <KundInfo
isFrom={0}
Kund={this.state.Mote.Kund}
onchangeHanelKund={this.onchangeHanelKund}
selectthisKund={this.selectthisKund}
/>
{
    isEmpty(this.state.Mote.Kund.Orgnr)?"":
    <CustomScrollbars className="module-side-scroll scrollbar"
    style={{height: '600px'}}>
        <Grid container>
            <Grid item md={4} className="py-1 ">
            <Paper variant="outlined" className={"p-1 m-1"}>
            <IntlMessages id="notification.info"/>
            <Kontakt
        userRole={this.props.authUser.user_role}
        Kontakt={this.state.Mote.Kontakt}
        InViteKontakt={this.state.Mote.InViteKontakt}
        Kontakter={isEmpty(this.props.KontakterList)?[]:this.props.KontakterList}
        onchangeHanelKontakt={this.onchangeHanelKontakt}
        onchangeHanelKontakt2={this.onchangeHanelKontakt2}
        onchangeHanelInViteKontakt={this.onchangeHanelInViteKontakt}
    />
    <Ansvarig
    CanSeeInviteFrom={this.props.authUser.user_CanSeeInviteFrom}
        userRole={this.props.authUser.user_role}
        MotUser={this.state.Mote.MotUser}
        onchangeHanelMotUser={this.onchangeHanelMotUser}
        ansvarig={this.state.Mote.ansvarig}
        HasTeam={this.state.Mote.HasTeam}
        onchangeHanelansvarig={this.onchangeHanelansvarig}
        MedArbetare={this.state.Mote.MedArbetare}
        onchangeHanelMedArbetare={this.onchangeHanelMedArbetare}
        HasOutlook={this.props.HasOutlook}
        onchangeHanelHasTeam={this.onchangeHanelHasTeam}
        SendNSms={this.state.Mote.SendNSms}
        onchangeHanelSendSms={this.onchangeHanelSendSms}
        TeleNummer={this.state.Mote.TeleNummer}
        onchangeHanelTeleNummer={this.onchangeHanelTeleNummer}
        InViteKontakt={this.state.Mote.InViteKontakt}
        onchangeHanelInViteKontakt={this.onchangeHanelInViteKontakt}
        InViteFrom={this.state.Mote.inViteFrom}
        KontaktEmail={this.state.Mote.Kontakt.Email}
        onchangeHanelInViteFrom={this.onchangeHanelInViteFrom}
    />
   
    <AvtalProspekt
        Avtal={this.state.Mote.Avtal}
        ListOfAVPro={this.props.ListOfAVPro}
        AvtalType={this.state.Mote.AvtalType}
        ProspektDeadline={this.state.Mote.ProspektDeadline}
        startDatetime={this.state.Mote.startDatetime}
        nyttBefintlig={this.state.Mote.Event.nyttBefintlig}
        onchangeHanelEvent={this.onchangeHanelEvent}
        onchangeHanelAvtal={this.onchangeHanelAvtal}
        onchangeHanelProspektDeadline={this.onchangeHanelProspektDeadline}
        onchangeHanelAvtalType={this.onchangeHanelAvtalType}
        onchangeTaggar={this.onchangeTaggar}
    />
    </Paper>
            </Grid>
            <Grid item md={4}  className="py-1 ">
                
            <Paper variant="outlined" className={"p-1 m-1"}>
            <IntlMessages id="Calendar" />
            <Mote
            signatures={this.props.signatures}
            onAddSignatur={this.onAddSignatur}
            HasOutlook={this.props.HasOutlook}
            Event={this.state.Mote.Event}
            ansvarig={this.state.Mote.ansvarig}
            onchangeHanelEvent={this.onchangeHanelEvent}
            onChangeDateRange={this.onChangeDateRange}
            EventAfid={this.props.authUser.user_Afid}
            />
    </Paper>
            </Grid>

       
        <Grid item md={4} className="py-1 ">
      <Paper variant="outlined" className={"p-1 m-1"}>
      <IntlMessages id="input.internal.comment"/>
      <AnteckningDelJ
        commentText={this.state.Mote.Event.Internkommentar}
        placeHolder={InterKommPlaceholder}
        handleupdatecommentText={(Komm)=>this.onchangeHanelEvent("Internkommentar",Komm)}
        disabled={false}
        />
 
      </Paper>      
      {
        parseInt(this.props.HasOutlook)!== 2?
      <Paper variant="outlined" className={"p-1 m-1"}>
        <IntlMessages id="Attachments"/>
        <FilesBilagor
        Meta="Files"
        Value={this.state.Mote.Event.Files}
        onchangeHanelEvent={this.onchangeHanelEvent}
        />
      </Paper>      
      :""}
  </Grid>
  </Grid>
   
    </CustomScrollbars>
}
        </Grid>

        
    </Grid>


</DialogContent>
{
    this.state.error? 
    <Alert severity="warning">{this.state.errorMessage}</Alert>
    :""
}
<DialogActions> 
<div className="d-flex w-100">
<div>
    <Button
    onClick={this.handleClose}
    className="jr-btn"
    variant="outlined"
    color="default"
    >
        <IntlMessages id="Cancel"/>
    </Button>
    </div> 
    <div className="ml-auto">
        <Button
        variant="contained"
        color="primary"
        className="jr-btn"
        onClick={this.createNewEvent}
        ><IntlMessages id="Book.aMeeting"/></Button>
    </div>
</div>          
</DialogActions>
            </Dialog>
        );
    }
}

export default compose(
    withStyles(styles),
    (withMediaQuery([
        ['fullScreen', theme => theme.breakpoints.down('xs'), {
          defaultMatches: true
        }]
      ])),
    connect(mapStateToProps,mapDispatchToProps),
    injectIntl
)(PopUpBM);